import { jsx as _jsx } from "react/jsx-runtime";
import { Link as GatsbyLink } from 'gatsby';
export default function Link(props) {
    /* TODO: Remove the ts-ignore */
    /* @ts-ignore */
    return _jsx(GatsbyLink, { ...props });
}
